import { app } from '../../../../../../app';
import { Controller } from './send-verification-emails.controller';

app.component('companyUserDirectoriesDirectoryGroupsAllAccountsVerify', {
    bindings: {
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./send-verification-emails.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/verify/send-verification-emails.component.js